import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { TicketService } from 'src/app/private/services/tickets.service';
import { UploadService } from 'src/app/private/services/upload.service';
import { SharedModule } from 'src/app/private/shared/shared.module';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';

@Component({
  selector: 'app-create-ticket',
  imports: [SharedModule],
  templateUrl: './create-ticket.component.html',
  styleUrl: './create-ticket.component.scss'
})
export class CreateTicketComponent {

  @Input() type: string = 'Create';
  @Input() ticketData: any;
  @Output() closeDialog = new EventEmitter();
  @Output() reload = new EventEmitter();
  @Input() users: any[] = []; // Assuming users are passed as input
  attachments: any[] = []; // Store selected files

  isSubmitted = false;
  btnLoading = false;

  ticketForm: FormGroup;

  ticketStatusOptions = ["New", "Open", "In Progress", "On Hold", "Esclated",
    "Resolved", "Closed", "Canceled", "Draft", "Reopened", "Deleted"];
  priorityOptions = ['Low', 'Medium', 'High'];
  sourceOptions = ['Tina', 'Email', 'Call', 'Web'];
  campusOptions = [
    { id: '1', name: 'Main Campus' },
    { id: '2', name: 'Delhi Campus' }
  ];

  files: any[] = [];
  totalFiles: any[] = [];
  uploadedUrls: string[] = [];
  loading = false;
  imgTitle = 'Upload Attachments';


  constructor(
    private fb: FormBuilder,
    private messageService: MessageService,
    private api: TicketService,
    private localStorage: LocalStorageService,
    private uploadService: UploadService
  ) {
    this.ticketForm = this.fb.group({
      title: ['', Validators.required],
      ticket_desc: ['', Validators.required],
      ticket_status: ['Open', Validators.required],
      priority: ['Low', Validators.required],
      source: ['', Validators.required],
      assign_to: [null],
      campus_id: [this.localStorage.getCampusId() || ''],
      attachments: [[]]
    });
  }

  ngOnInit() {
    if (this.type === 'Update' && this.ticketData) {
      console.log('Updating ticket with data:', this.ticketData);


      this.ticketForm.patchValue({
        title: this.ticketData.title,
        ticket_desc: this.ticketData.ticket_desc,
        ticket_status: this.ticketData.ticket_status,
        priority: this.ticketData.priority,
        source: this.ticketData.source,
        assign_to: this.ticketData.assign_to || null,
        campus_id: this.ticketData.campus_id || '',
        attachments: this.ticketData.attachments || []
      });

      this.totalFiles = this.ticketData.attachments.map((url: string) => ({
        file: { name: this.extractFileName(url) }, // mock File-like structure
        preview: url
      }));

      this.uploadedUrls = [...this.ticketData.attachments]; // so remove works correctly

    }


  }

  extractFileName(url: string): string {
    return url.split('/').pop() || 'file';
  }

  handleCloseDialog() {
    this.closeDialog.emit();
  }

  onSubmit() {
    this.isSubmitted = true;

    if (this.ticketForm.valid) {
      const formValues = this.ticketForm.value;

      const payload = {
        ...formValues,
        organization_id: this.localStorage.getOrganizationId(),
        live_chat_agent_info_id: '',
        live_chat_data: {},

        // created_by: {
        //   user_id: this.localStorage.getUserId(),
        //   name: this.localStorage.getUserName(), // ensure this method exists
        //   email: this.localStorage.getUserEmail() // ensure this method exists

        // },
        created_by: {
          user_id: this.localStorage.getUserId(),
          name: this.localStorage.getUserFullName(),
          email: this.localStorage.getEmail()
        },

        assignee_detail: {
          name: formValues.assign_to ? this.users.find(user => user.value === formValues.assign_to)?.label : ''
        }
      };

      this.btnLoading = true;

      const apiCall = this.type === 'Create'
        ? this.api.createTicket(payload)
        : this.api.updateTicket({
          ticket_id: this.ticketData.ticket_id, id: this.ticketData.id,
          updated_by: {
            user_id: this.localStorage.getUserId(),
            name: this.localStorage.getUserFullName(),
            email: this.localStorage.getEmail()
          },
          ...payload
        });

      apiCall.subscribe({
        next: (res) => {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: `Ticket ${this.type === 'Create' ? 'created' : 'updated'} successfully` });
          this.ticketForm.reset();
          this.isSubmitted = false;
          this.reload.emit();
          this.handleCloseDialog();
          this.btnLoading = false;

        },
        error: (err) => {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: `Failed to ${this.type.toLowerCase()} ticket` });
          this.btnLoading = false;
        }
      });
    } else {
      this.messageService.add({ severity: 'error', summary: 'Validation Error', detail: 'Please fill all required fields' });
    }
  }


  onFileSelected(event: any) {
    const selectedFiles: FileList = event.target.files;
    const totalFiles = selectedFiles.length;
    let processedFiles = 0;

    if (totalFiles > 0) {
      this.files = [];
      for (let i = 0; i < totalFiles; i++) {
        const file = selectedFiles[i];
        const reader = new FileReader();

        reader.onload = (e: any) => {
          this.files.push({ file, preview: e.target.result });
          this.totalFiles.push({
            file: file,
            preview: e.target.result
          });
          processedFiles++;

          if (processedFiles === totalFiles) {
            this.uploadImages();
          }
        };

        reader.readAsDataURL(file);
      }
    } else {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'No files selected for upload' });
    }
  }

  uploadImages() {
    if (this.files.length > 0) {
      this.loading = true;
      this.imgTitle = 'Uploading...';

      const uploadPromises = this.files.map((fileObj) => {
        const formData = new FormData();
        const folder = `public/hospital-001/$001/profile`;
        formData.append('file', fileObj.file);
        formData.append('folders', folder);
        formData.append('bucket', 'global-upload-storage');

        return this.uploadService.uploadDocuments(formData).toPromise();
      });

      Promise.all(uploadPromises)
        .then((responses) => {
          responses.forEach((res: any) => {
            if (res) {
              this.uploadedUrls.push(res.url);
            }
          });

          // update attachments form control with URLs
          this.ticketForm.patchValue({
            attachments: this.uploadedUrls
          });
        })
        .catch((error) => {
          console.error('Error uploading images:', error);
          this.messageService.add({ severity: 'error', summary: 'Upload Error', detail: 'Failed to upload attachments' });
        })
        .finally(() => {
          this.loading = false;
          this.imgTitle = 'Upload Attachments';
        });

      console.log('Files:', this.totalFiles);
    } else {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'No files selected for upload' });
    }
  }

  removeFile(index: number) {
    this.totalFiles.splice(index, 1);
    this.uploadedUrls.splice(index, 1);

    this.ticketForm.patchValue({
      attachments: this.uploadedUrls
    });
  }

  isImage(file: string): boolean {
    return /\.(jpg|jpeg|png|gif|webp)$/i.test(file);
  }

  isVideo(file: string): boolean {
    return /\.(mp4|webm|ogg|mov)$/i.test(file);
  }

  isPDF(file: string): boolean {
    return /\.(pdf)$/i.test(file);
  }
}
